var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.16667H5.69167L8.675 6.175L7.5 5L2.5 10L7.5 15L8.675 13.8167L5.69167 10.8333H17.5V9.16667Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationPrevious);
export default __webpack_public_path__ + "static/media/pagination-previous.ec450cec.svg";
export { ForwardRef as ReactComponent };